import React from 'react';
import { Link } from 'react-router-dom';
import { FiSend } from "react-icons/fi";

const ContactCTA = () => {
  return (
    <div className="w-full px-4 md:px-10 max-w-7xl mx-auto mb-20 mt-20">
      <div className="w-full bg-white/60 dark:bg-white/5 backdrop-blur-xl rounded-xl p-10 md:p-14 flex flex-col items-center justify-center gap-4 text-center shadow-sm border border-white/20">
        <h2 className="text-3xl md:text-4xl font-bold text-designColor capitalize tracking-wide">
          You have a new project?
        </h2>
        <p className="text-lg text-gray-600 dark:text-gray-400 font-medium max-w-2xl">
          Contact me now and get discounts on your Web development projects.
        </p>
        <Link 
          to="/contacts"
          className="mt-4 btn-style905 rounded-lg px-8 py-3 flex items-center gap-2"
        >
          Contact me <FiSend />
        </Link>
      </div>
    </div>
  );
};

export default ContactCTA;
